<script setup lang="ts">
import {
    BBtn, BIcon, BTooltip,
} from '@/design-system';
import type { VBtn } from 'vuetify/components';

type PropsType = {
    icon: string;
    tooltip?: string;
    tooltipLocation?: 'top' | 'bottom' | 'left' | 'right' | 'start' | 'end';
    size?: VBtn['$props']['size'];
    variant?: VBtn['$props']['variant'];
    color?: VBtn['$props']['color'];
    density?: VBtn['$props']['density'];
    disabled?: VBtn['$props']['disabled'];
    loading?: VBtn['$props']['loading'];
    iconSize?: string | number;
    iconColor?: string;
};

withDefaults(defineProps<PropsType>(), {
    size: 'small',
    variant: 'text',
    color: 'default',
    density: 'comfortable',
    disabled: false,
    loading: false,
    tooltipLocation: 'top',
});

defineEmits<{
    click: [event: MouseEvent];
}>();

defineOptions({ inheritAttrs: false });
</script>

<template>
    <BTooltip
        v-if="tooltip"
        :location="tooltipLocation"
    >
        <template #activator="{ props: tooltipProps }">
            <BBtn
                v-bind="{ ...tooltipProps, ...$attrs }"
                icon
                :size="size"
                :variant="variant"
                :color="color"
                :density="density"
                :disabled="disabled"
                :loading="loading"
                @click="$emit('click', $event)"
            >
                <BIcon
                    :size="iconSize"
                    :color="iconColor"
                >{{ icon }}</BIcon
                >
            </BBtn>
        </template>
        <template #default>
            {{ tooltip }}
        </template>
    </BTooltip>

    <BBtn
        v-else
        v-bind="$attrs"
        icon
        :size="size"
        :variant="variant"
        :color="color"
        :density="density"
        :disabled="disabled"
        :loading="loading"
        @click="$emit('click', $event)"
    >
        <BIcon
            :size="iconSize"
            :color="iconColor"
        >{{ icon }}</BIcon
        >
    </BBtn>
</template>
